import React,{Component} from 'react';
import AppSaveRecordButton from '../pages/appsaverecordbutton';
import scanlogo from '../assets/images/scanlogo.png';
import { FilterConsumer, FilterContext } from '../context/FilterContext';

import {
    Page,
    PageContent,
    Navbar,
    NavLeft,
    NavRight,
    NavTitle,
    Block,
    List,
    ListInput,
    ListItem,
    Fab,
    Icon,
    Toggle,
    Row,
    Col,
    Link,
    Popup,
    Toolbar,
    Button
  } from 'framework7-react';

  export default class EditSubLine extends Component {
    constructor(props) {
      super(props);
  
      this.state = {
        clientdetail:[],
        name:'',
        phone:'',
        status:1,
        remarks:'',
        lineid:'',
        linelist:[],
        colwidth:80,
        ismount:false,
        linename:'',
        issmartline:false,
        hassmartline:false,
        areaid:'',
        arealist:[],
        areaname:false,
        issmartarea:false,
        hassmartarea:false
      };

      this.handleUserInput    = this.handleUserInput.bind(this);
      this.fetchNewArea       = this.fetchNewArea.bind(this);
      this.fetchNewLine       = this.fetchNewLine.bind(this);

    }

    componentDidMount(){

      let clientdetail   = JSON.parse(localStorage.getItem('agency_clientdetail'));

      this.setState(()=>{
        return{
          clientdetail:clientdetail
        }
      },()=>{

        if(Number(this.state.clientdetail.islineman) === 1 || Number(this.state.clientdetail.ismanager) === 1)
        {
          this.setState({colwidth:100});
        }
        setTimeout(()=> {

          this.setState({ismount:true});

        }, 1200);

        this.getDetail();
        this.hideSplashScreen();
        this.areaAutocompletePopup();
        this.lineAutocompletePopup();

      });
      
    }

    componentwillunmount(){

      this.onPageBeforeRemove();

    }

    onPageBeforeRemove(){

      const self = this;
      self.autocompleteAreaPopup.destroy();
      self.autocompleteLinePopup.destroy();

    }

    hideSplashScreen(){
      document.getElementById("splash-screen").style.visibility = "hidden";
    }

    handleUserInput(e){

      const name  = e.target.name;
      const value = e.target.value;

      if(name === 'status')
      {
        this.setState({status:!this.state.status});
      }
      else
      {
        this.setState(()=>{
          return{
            [name]: value
          }
        });
      }
    }

    getDetail(){

        const self      = this;
        const app       = self.$f7;
        const router    = self.$f7router;

        if(!this.$f7.online)
        {
          return;
        }

        const bodyFormData = {
            Mode:'GetSubLineDetail',
            clientid:self.state.clientdetail.id,
            recordid:self.props.f7route.params.id,
        };

        const accesstoken  = localStorage.getItem('agency_accesstoken');
          
        app.request.setup({
          headers:{
            Authorization: `${accesstoken}`
          }
        });

        app.request.promise.post(`${app.passedParams.serverurl}api/subline.php?t=${Date.now()}`,bodyFormData)
        .then((res)=> {

            // Hide Pull To Refresh
            app.ptr.done();

            const resdata = JSON.parse(res.data);
  
            if(resdata.success === true)
            {
              this.setState({
  
                name:resdata.detail.name,
                phone:resdata.detail.phone,
                status:resdata.detail.status,
                remarks:resdata.detail.remark,
                areaid:resdata.detail.areaid,
                lineid:resdata.detail.lineid,
                isptr:false,

              },()=>{
                this.Dom7('#autocomplete-area-name2').text(resdata.detail.areaname);
                this.Dom7('#autocomplete-line-name2').text(resdata.detail.linename);
              });
            }
            else
            {
              this.setState({
  
                isptr:false,

              });
            }
  
        }).catch(e => {
            console.log(e);
        });
    }

    areaAutocompletePopup(){

      const self = this;
      const app = self.$f7;
      const $ = self.$$;

      self.autocompleteAreaPopup = app.autocomplete.create({

        openIn: 'popup',
        valueProperty: 'name',
        textProperty: 'name',
        typeahead: true,
        openerEl: '#autocomplete-area-popup a',
        closeOnSelect: true,
        routableModals:true,
        url:'selectarea/',
        requestSourceOnOpen:true,

        source(query, render) {
          const autocomplete = this;
          const results = [];

          app.preloader.show();

          const accesstoken  = localStorage.getItem('agency_accesstoken');

          app.request({
            
            method: 'POST',
            dataType: 'json',
            url: `${app.passedParams.serverurl}api/area.php?t=${Date.now()}`,
            headers: {
                Authorization: `${accesstoken}`
            },
            data: {
              Mode:'GetArea',
              clientid:self.state.clientdetail.id,
            },
            success(res) {
            // Find matched items

              if(res.success === true)
              {
                self.setState(()=>{
                  return{
                    arealist:res.recordlist,
                  }
                },()=>{

                  const searchlinelist  = self.state.arealist;

                  for (let i = 0; i < searchlinelist.length; i += 1) {
                    if (searchlinelist[i].name.toLowerCase().indexOf(query.toLowerCase()) >= 0) results.push(searchlinelist[i]);
                  }
                  
                })
              }

              // Hide Preoloader
              app.preloader.hide();
              // Render items by passing array with result items
              render(results);
            },
          });
        },
        on: {
          change(value) {

            self.Dom7('#autocomplete-area-name2').text(value[0].name);
            $('.autocomplete-area-popup').removeClass('error');
            
            self.setState({
              areaid:value[0].id
            });

          },
        },
      });
    }

    lineAutocompletePopup(){

      const self = this;
      const app = self.$f7;
      const $ = self.$$;

      self.autocompleteLinePopup = app.autocomplete.create({

        openIn: 'popup',
        valueProperty: 'name',
        textProperty: 'name',
        typeahead: true,
        openerEl: '#autocomplete-line-popup a',
        closeOnSelect: true,
        routableModals:true,
        url:'selectline/',
        requestSourceOnOpen:true,

        source(query, render) {
          const autocomplete = this;
          const results = [];

          app.preloader.show();

          const accesstoken  = localStorage.getItem('agency_accesstoken');

          app.request({
            
            method: 'POST',
            dataType: 'json',
            url: `${app.passedParams.serverurl}api/line.php?t=${Date.now()}`,
            headers: {
                Authorization: `${accesstoken}`
            },
            data: {
              Mode:'GetLine',
              clientid:self.state.clientdetail.id,
              areaid:self.state.areaid,
              type:'subline2',
            },
            success(res) {
            // Find matched items

              if(res.success === true)
              {
                self.setState(()=>{
                  return{
                    linelist:res.recordlist,
                  }
                },()=>{

                  const searchlinelist  = self.state.linelist;

                  for (let i = 0; i < searchlinelist.length; i += 1) {
                    if (searchlinelist[i].name.toLowerCase().indexOf(query.toLowerCase()) >= 0) results.push(searchlinelist[i]);
                  }
                  
                })
              }

              // Hide Preoloader
              app.preloader.hide();
              // Render items by passing array with result items
              render(results);
            },
          });
        },
        on: {
          change(value) {

            self.Dom7('#autocomplete-line-name2').text(value[0].name);
            $('.autocomplete-line-popup').removeClass('error');
            
            self.setState({
              lineid:value[0].id
            });

          },
        },
      });
    }

    fetchNewArea(newareaid, newarea){

      this.setState(()=>{

        return{

          areaid:newareaid

        }

      },()=>{

        this.Dom7('#autocomplete-area-name2').text(newarea);

      })

    }

    fetchNewLine(newlineid, newline){

      this.setState(()=>{

        return{

          lineid:newlineid

        }

      },()=>{

        this.Dom7('#autocomplete-line-name2').text(newline);

      })

    }

    saveDetail(){
      const self      = this;
      const app       = self.$f7;
      const router    = self.$f7router;

      let errmsg    = "";

      if(!this.$f7.online)
      {
        return;
      }

      app.input.validateInputs('.adddata');

      if((this.state.areaid === "" || this.state.areaid === undefined) && errmsg === "")
      {
        errmsg  = "Please select an Area";
      }

      if(this.state.areaid === "" || this.state.areaid === undefined)
      {
        this.$$('.autocomplete-area-popup').addClass('error');
      }
      else
      {
        this.$$('.autocomplete-area-popup').removeClass('error');
      }

      if((this.state.lineid === "" || this.state.lineid === undefined) && errmsg === "")
      {
        errmsg  = "Please select Line";
      }

      if(this.state.lineid === "" || this.state.lineid === undefined)
      {
        this.$$('.autocomplete-line-popup').addClass('error');
      }
      else
      {
        this.$$('.autocomplete-line-popup').removeClass('error');
      }

      if(this.state.name === "" && errmsg === "")
      {
        errmsg  = "Please enter name";
      }

      if(errmsg !== "")
      {
        const toastWithButton = app.toast.create({
          text: errmsg,
          closeButton: true,
          closeTimeout: 3000,
        });

        toastWithButton.open();
  
        return false;
      }

      const bodyFormData = {
          Mode:'EditSubLine',
          clientid:self.state.clientdetail.id,
          recordid:self.props.f7route.params.id,
          name:self.state.name,
          phone:self.state.phone,
          status:Number(self.state.status),
          remarks:self.state.remarks,
          areaid:self.state.areaid,
          lineid:self.state.lineid,
      };

      app.preloader.show();

      // Simulate Ajax Request
      setTimeout(()=> {

        const accesstoken  = localStorage.getItem('agency_accesstoken');
          
        app.request.setup({
          headers:{
            Authorization: `${accesstoken}`
          }
        });

        app.request.promise.post(`${app.passedParams.serverurl}api/subline.php?t=${Date.now()}`,bodyFormData)
        .then((res)=> {

            // We got user data from request

            // Hide Preloader
            app.preloader.hide();
  
            const resdata = JSON.parse(res.data);

            const toastWithButton = app.toast.create({
              text: resdata.toastmsg,
              closeButton: true,
              closeTimeout: 3000,
            });

            toastWithButton.open();
  
            if(resdata.success === true)
            {
                router.navigate('/sublines/');             
            }
  
        }).catch(e => {
            console.log(e);
        });

      }, 1000);

    }

    render(){
      
      const{colwidth, clientdetail, lineid, ismount} = this.state;

      return(
        <FilterConsumer>{(value)=>{

            const{singlearea, singleline} = value;
  
            if(ismount === true)
            {
              setTimeout(()=> {

                if((singlearea.id !== this.state.areaid) && singlearea.id > 0)
                {
                  this.fetchNewArea(singlearea.id, singlearea.name);
                }
  
                if((singleline.id !== lineid) && singleline.id > 0)
                {
                  this.fetchNewLine(singleline.id, singleline.name);
                }
    
              }, 500)
              
            }
  
            return(
                <Page pageContent={false} className="page" name="EditSubLine">
                      <Navbar sliding={true}>
                          <NavLeft>
                            <Link iconIos="f7:menu" iconAurora="f7:menu" iconMd="material:menu" panelOpen="left" className="smallbox"/>
                            <Link href={`/dashboard/`} className="clearmenupadding">
                              <img className="navbarlogo" src={scanlogo} alt="logo" />
                            </Link>
                          </NavLeft>
                          <NavTitle>Edit Sub Line</NavTitle>
                          <NavRight className="right-with-menu">
                          </NavRight>
                      </Navbar>
                      <PageContent>
                      <Block>
                        <Row>
                            <Col width={colwidth}>
                            <List noHairlinesMd className="zeromargin">
                              <ListItem link="#" id="autocomplete-area-popup" className="autocomplete-area-popup" title="Area">
                                <div slot="after" id="autocomplete-area-name2">Select</div>
                              </ListItem>
                            </List>
                            </Col>
                            {
                              clientdetail.islineman || clientdetail.ismanager ? null:(
                                <Col width="15" style={{marginTop:'8px',marginRight:'15px'}}>
                                  <Link onClick={()=>{
                                    if(this.$f7.online)
                                    {
                                      this.$f7router.navigate('addareapopup/')
                                    }
                                  }}>
                                    <Icon ios="f7:plus" aurora="f7:plus" md="material:add_circle" style={{fontSize:'30px'}}></Icon>
                                  </Link>
                                </Col>
                              )
                            }
                        </Row>
                        <Row>
                          <Col width={colwidth}>
                          <List noHairlinesMd className="zeromargin">
                            <ListItem link="#" id="autocomplete-line-popup" className="autocomplete-line-popup" title="Line">
                              <div slot="after" id="autocomplete-line-name2">Select</div>
                            </ListItem>
                          </List>
                          </Col>
                          {
                            clientdetail.islineman || clientdetail.ismanager ? null:(
                              <Col width="15" style={{marginTop:'8px',marginRight:'15px'}}>
                                <Link onClick={()=>{
                                  if(this.$f7.online)
                                  {
                                    this.$f7router.navigate('addlinepopup/')
                                  }
                                }}>
                                  <Icon ios="f7:plus" aurora="f7:plus" md="material:add_circle" style={{fontSize:'30px'}}></Icon>
                                </Link>
                              </Col>
                            )
                          }
                      </Row>
                      <List noHairlinesMd style={{marginBottom:'5px'}}>
      
                          <ListInput
                              name="name"
                              className="adddata"
                              label="Name"
                              floatingLabel
                              type="text"
                              onInput={this.handleUserInput}
                              placeholder="Name"
                              value={this.state.name}
                              clearButton required validate
                          >
                          </ListInput>

                          <ListInput
                              name="remarks"
                              label="Remarks"
                              floatingLabel
                              type="textarea"
                              onInput={this.handleUserInput}
                              value={this.state.remarks}
                              resizable
                              placeholder="Remarks"
                          >
                          </ListInput>
  
                          <ListItem title="Status">
                            <Toggle slot="after" name="status" checked={Number(this.state.status) === 1} value="1" onChange={this.handleUserInput}></Toggle>
                          </ListItem>
  
                      </List>
                  </Block>
                  <br /><br />
                  </PageContent>
                  <AppSaveRecordButton saveDetail={this.saveDetail.bind(this)} />
                </Page>
            );
          }}</FilterConsumer>
      );
    }
}